import { Alert, Snackbar } from '@mui/material';
import React, { ReactNode, useEffect, useState } from 'react';
import SnackbarManager from './SnackbarManager';

export interface SnackbarViewProps {
    readonly timeout?: number;
    readonly severity?: 'success' | 'info' | 'warning' | 'error';
    readonly message: ReactNode;
}

export default function SnackbarContainer() {
    const [props, setProps] = useState<SnackbarViewProps | undefined>();

    useEffect(() => {
        SnackbarManager.addChangeListener(setProps);
    }, []);

    return props !== undefined ? (
        <Snackbar open={props !== undefined} autoHideDuration={props?.timeout || 2500}>
            <Alert variant="filled" severity={props?.severity}>
                {props?.message}
            </Alert>
        </Snackbar>
    ) : null;
}
